import { OrderType, UserContractModel } from "@/api/userApi";

import { OrderModel } from "@/api/userApi";
import Decimal from "decimal.js";

export const getOrderPrice = (order: OrderModel): number | null => {
  switch (order.type) {
    case OrderType.Limit:
      return order.limitPrice;
    case OrderType.Stop:
      return order.stopPrice;
    case OrderType.StopLimit:
      return order.limitPrice ?? order.stopPrice;
    case OrderType.TrailingStop:
      return order.stopPrice;
  }
  return null;
};

export const setSuspendedOrderPrice = (order: OrderModel, parentOrder: OrderModel, contract: UserContractModel) => {
  const parentOrderPrice = getOrderPrice(parentOrder);
  if (!parentOrderPrice) return null;

  const parentOrderPriceDecimal = new Decimal(parentOrderPrice);
  const tickValue = new Decimal(contract.tickSize);

  switch(order.type) {
    case OrderType.Limit:
      order.limitPrice = parentOrderPriceDecimal.add(tickValue.mul(order.trailDistance)).toNumber();
      break;
    case OrderType.Stop:
      order.stopPrice = parentOrderPriceDecimal.add(tickValue.mul(order.trailDistance)).toNumber();
      break;
    case OrderType.TrailingStop:
      order.stopPrice = parentOrderPriceDecimal.add(tickValue.mul(order.trailDistance)).toNumber();
      break;
  }
};
